module.exports = __webpack_public_path__ + "74c8d5417179ab29105f291511e9e0f0.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/burger-hat.png
 ** module id = 477
 ** module chunks = 0
 **/